module.exports = __webpack_public_path__ + "static/media/teez.73eb8288.png";